// extracted by mini-css-extract-plugin
export var editButton = "_ji-0";